import React, { useEffect, useState } from 'react'
import AppSidebar from '../../../components/AppSidebar'
import AppHeader from '../../../components/AppHeader'
import PageHeader from '../../../components/PageHeader'
import { currencyOptions, discountTypeOptions } from '../../../utils/OptionUtils'
import DocumentForm from '../../../components/DocumentForm'
import CustomersService from '../../../services/CustomersService'
import { toast, ToastContainer } from 'react-toastify'
import SelectTag from '../../../components/SelectTag'
import { useForm } from 'react-hook-form'

const CreateCreditNote = () => {
  const { control } = useForm();
  const [customerOptions, setCustomerOptions] = useState([]);
  const fetchCustomersList = async () => {
    try {
      const response = await CustomersService.listAll();
      if (response.status === 200) {
        setCustomerOptions(response?.data?.data?.map((item) => ({
          label: item.company,
          value: item.id,
        })));
      }
    } catch (error) {
      toast.error(error?.message || "An error occurred");
    }
  }
  useEffect(() => {
    fetchCustomersList();
  }, [])

  return (
    <>
      <AppSidebar />
      <div className="main-content">
        <AppHeader />
        <div className="container-fluid">
          <PageHeader title="Create Credit Note" className="btn btn-sm btn-primary" link_to="/credit-notes" button_label="Back" />
          <div className="card mt-4 shadow-sm">
            <div className="card-body">
              <form>
                <div className="row">
                  {/* Left Column */}
                  <div className="col-12 col-xl-6">
                    <div className="mb-3">
                      <label htmlFor="customer" className="form-label">Customer</label>
                      <SelectTag
                        options={customerOptions}
                        name={"customer"}
                        label={"Customer"}
                        control={control}
                      />
                    </div>
                    <div className="row">
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="bill_to" className="form-label">Bill To</label>
                          <textarea className="form-control" name="bill_to" id="bill_to" rows="3"></textarea>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="ship_to" className="form-label">Ship To</label>
                          <textarea className="form-control" name="bill_to" id="bill_to" rows="3"></textarea>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="invoice_date" className="form-label">Credit Note Date</label>
                          <input type="date" className="form-control" name="invoice_date" id="invoice_date" />
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="due_date" className="form-label">Credit Note#</label>
                          <div className="form-group">
                            <div className="input-group">
                              <span className="input-group-text">CN-</span>
                              <input type="text" className="form-control" name="due_date" id="due_date" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Right Column */}
                  <div className="col-12 col-xl-6">
                    <div className="row">
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="currency" className="form-label">Currency</label>
                          <SelectTag
                            options={currencyOptions}
                            name={"currency"}
                            label={"Currency"}
                            control={control}
                            defaultValue={'inr'}
                          />
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="discount_type" className="form-label">Discount Type</label>
                          <SelectTag
                            options={discountTypeOptions}
                            name={"discount_type"}
                            label={"Discount Type"}
                            control={control}
                            defaultValue={'no_discount'}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-12">
                        <div className="mb-3">
                          <label htmlFor="reference" className="form-label">Reference#</label>
                          <input type="text" className="form-control" name="reference" id="reference" />
                        </div>
                      </div>
                    </div>
                    <div className="mb-3">
                      <label htmlFor="notes" className="form-label">Admin Notes</label>
                      <textarea className="form-control" name="notes" id="notes" rows="3"></textarea>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <DocumentForm />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  )
}

export default CreateCreditNote